// @flow
import constants from '../constants';

/**
 * form 送信先 endpoint を返します
 * @param {string} surveyId path 末尾に付与する survey ID
 * @return {string} api endpoint 返します
 */
const api = ({ surveyId }: { surveyId: string } = {}) => {
  return `${constants.SURVEY_API_ENDPOINT_BASE}${surveyId}`;
};

export default api;



// WEBPACK FOOTER //
// ./src/phase2/survey/app/api/index.js